<template>
  <section>
    <div class="container">
      <div class="row justify-content-center justify-content-md-between">
        <div class="col-auto px-0">
          <mdb-btn flat dark-waves icon="arrow-left" type="button" title="Regresar" @click="$router.go(-1)">
            Regresar
          </mdb-btn>
        </div>
      </div>
      <div class="encabezado-detalles">
        <header class="h4-responsive text-center pt-3">Reporte</header>
        <div class="row mx-0 mt-2">
          <div class="col-12 col-md-4">
            <span class="small-block font-titulo">Nombre del reporte</span>
            <p>
              Actividades de ventas del vendedor
            </p>
          </div>
          <div class="col-12">
            <span class="small-block font-titulo">Descripción</span>
            <p class="mb-1">
              Cumplimiento de actividades de ventas de todos los vendedores.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4 col-xl-3">
          <mdb-input v-model="fechaMes" type="month" label="Mes" class="my-2" outline />
        </div>
      </div>
    </div>
    <div v-if="cargando" class="mensaje-no-items py-3">
      <LoaderKel />
      <p class="texto mt-2">
        Cargando
      </p>
    </div>
    <!-- Mensaje cuando el vendedor seleccionado no tiene pedido -->
    <div v-else-if="!data.length" class="mensaje-no-items pb-3">
      <font-awesome-icon icon="clipboard-list" size="5x" class="icono" />
      <p class="texto">No hay actividades según los parámetros seleccionados</p>
    </div>
    <div class="container" v-else>
      <div class="col-12 col-sm px-0">
        <header class="h4-responsive">Actividades del mes de {{ mesDelAño() }}</header>
      </div>
      <div class="table-container">
        <div class="table-wrapper">
          <table>
            <thead>
              <th>
                <div class="ancho-2">
                  vendedor
                </div>
              </th>
              <th>
                <div>
                  TOTAL CLIENTES
                  <span class="small-block">
                    Despachos
                  </span>
                </div>
              </th>
              <th>
                <div>
                  Clientes despachados
                  <span class="small-block">
                    % Despachado
                  </span>
                </div>
              </th>
              <th>
                <div>
                  Clientes no despachados
                  <span class="small-block">
                    % No despachado
                  </span>
                </div>
              </th>
              <th>
                <div>
                  Facturado
                </div>
              </th>
              <th>
                <div>
                  Clientes nuevos
                  <span class="small-block">
                    Clientes llamados
                  </span>
                  <span class="small-block">
                    clientes contactados
                  </span>
                </div>
              </th>
              <th>
                <div>
                  % de cumplimiento
                </div>
              </th>
              <th>
                <div>
                  visitas presenciales
                </div>
              </th>
              <th>
                <div>
                  días atendidos
                </div>
              </th>
            </thead>
            <tbody>
              <tr v-for="(p, i) in data" :key="i">
                <td data-columna="Vendedor">
                  <div>
                    <span>
                      {{ p.nombre_vendedor }}
                    </span>
                  </div>
                </td>
                <td data-columna="Total Clientes / Despachos">
                  <div class="d-flex flex-column">
                    <span>
                      {{ p.total_clientes }}
                    </span>
                    <span>
                      {{ p.total_despachos }}
                    </span>
                  </div>
                </td>
                <td data-columna="Clientes despachados / % Despachado" :class="{ 'celda-destacada-amarilla': parseFloat(p.porcentaje_con_despacho) > 50 }">
                  <div class="d-flex flex-column">
                    <span>
                      {{ p.clientes_despachados }}
                    </span>
                    <span>
                      {{ p.porcentaje_con_despacho }}%
                    </span>
                  </div>
                </td>
                <td data-columna="Clientes no despachados / % No despachado">
                  <div class="d-flex flex-column">
                    <span>
                      {{ p.clientes_no_despachados }}
                    </span>
                    <span>
                      {{ p.porcentaje_sin_despacho }}%
                    </span>
                  </div>
                </td>
                <td data-columna="Facturado">
                  <span>
                    {{ p.total_facturado }}
                  </span>
                </td>
                <td data-columna="Clientes nuevos / Clientes llamados / Clientes contactados" :class="{ 'celda-destacada-amarilla': parseFloat(p.clientes_nuevos) > 5 }">
                  <div class="d-flex flex-column">
                    <span>
                      {{ p.clientes_nuevos }}
                    </span>
                    <span>
                      {{ p.total_llamadas }}
                    </span>
                    <span>
                      {{ p.clientes_contactados }}
                    </span>
                  </div>
                </td>
                <td data-columna="Porcentaje de cumplimiento" :class="{ 'celda-destacada-amarilla': parseFloat(p.porcentaje_cumplimiento) == 100 }">
                  <span>
                    {{ p.porcentaje_cumplimiento }}%
                  </span>
                </td>
                <td data-columna="Visitas presenciales">
                  <span>
                    {{ p.total_visitas }}
                  </span>
                </td>
                <td data-columna="Días atendidos">
                  <span>
                    {{ p.dias_atendiendo }}
                  </span>
                </td>
              </tr>
              <tr class="fila-totales" v-if="data.length">
                <td data-columna="Vendedor">
                  <div>
                    <span class="font-weight-bold">
                      TOTALES
                    </span>
                  </div>
                </td>
                <td data-columna="Total Clientes / Despachos">
                  <div class="d-flex flex-column">
                    <span class="font-weight-bold">
                      {{ totales.total_clientes }}
                    </span>
                    <span class="font-weight-bold">
                      {{ totales.total_despachos }}
                    </span>
                  </div>
                </td>
                <td data-columna="Clientes despachados / % Despachado">
                  <div class="d-flex flex-column">
                    <span class="font-weight-bold">
                      {{ totales.clientes_despachados }}
                    </span>
                    <span class="font-weight-bold">
                      {{ totales.porcentaje_con_despacho }}%
                    </span>
                  </div>
                </td>
                <td data-columna="Clientes no despachados / % No despachado">
                  <div class="d-flex flex-column">
                    <span class="font-weight-bold">
                      {{ totales.clientes_no_despachados }}
                    </span>
                    <span class="font-weight-bold">
                      {{ totales.porcentaje_sin_despacho }}%
                    </span>
                  </div>
                </td>
                <td data-columna="Facturado">
                  <span class="font-weight-bold">
                    {{ totales.total_facturado }}
                  </span>
                </td>
                <td data-columna="Clientes nuevos / Clientes llamados / Clientes contactados">
                  <div class="d-flex flex-column">
                    <span class="font-weight-bold">
                      {{ totales.clientes_nuevos }}
                    </span>
                    <span class="font-weight-bold">
                      {{ totales.total_llamadas }}
                    </span>
                    <span class="font-weight-bold">
                      {{ totales.total_contactos }}
                    </span>
                  </div>
                </td>
                <td data-columna="Porcentaje de cumplimiento">
                  <span class="font-weight-bold">
                    {{ totales.porcentaje_cumplimiento }}%
                  </span>
                </td>
                <td data-columna="Visitas presenciales">
                  <span class="font-weight-bold">
                    {{ totales.total_visitas }}
                  </span>
                </td>
                <td data-columna="Días atendidos">
                  <span class="font-weight-bold">
                    {{ totales.dias_atendiendo }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>

    <AlertaMensaje :alerta-mensaje="alertaMensaje" @cerrar="alertaMensaje.contenido = ''" />
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from 'mdbvue'
import AlertaMensaje from '@/components/AlertaMensaje.vue'
import LoaderKel from '@/components/LoaderKel.vue'
import { apiPost } from '@/funciones/api.js'
import { convertirNumeroAFixed } from '@/funciones/funciones.js'
export default {
  name: 'Actividades',
  components: {
    mdbInput,
    mdbBtn,
    AlertaMensaje,
    LoaderKel
  },
  data () {
    return {
      cargando: false,
      responsive: { vendedor: 'col-12', btnRestablecer: 'col-12 col-md-auto' },
      fechaMes: (new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2)).toString(),
      alertaMensaje: { contenido: '' },
      restablecer: false,
      data: []
    }
  },
  computed: {
    totales () {
      if (!this.data.length) return {}

      const totales = {
        total_clientes: 0,
        total_despachos: 0,
        clientes_despachados: 0,
        clientes_no_despachados: 0,
        total_facturado: 0,
        clientes_nuevos: 0,
        total_llamadas: 0,
        total_visitas: 0,
        dias_atendiendo: 0,
        total_contactos: 0
      }

      let planificadas = 0
      let cumplidas = 0

      this.data.forEach(item => {
        totales.total_clientes += parseFloat(item.total_clientes) || 0
        totales.total_despachos += parseFloat(item.total_despachos) || 0
        totales.clientes_despachados += parseFloat(item.clientes_despachados) || 0
        totales.clientes_no_despachados += parseFloat(item.clientes_no_despachados) || 0
        totales.total_facturado += parseFloat(item.total_facturado) || 0
        totales.clientes_nuevos += parseFloat(item.clientes_nuevos) || 0
        totales.total_llamadas += parseFloat(item.total_llamadas) || 0
        totales.total_visitas += parseFloat(item.total_visitas) || 0
        totales.dias_atendiendo += parseFloat(item.dias_atendiendo) || 0
        totales.total_contactos += parseFloat(item.clientes_contactados) || 0
        planificadas += parseFloat(item.acciones_planificadas)
        cumplidas += parseFloat(item.acciones_cumplidas)
      })

      const totalClientes = totales.total_clientes
      totales.porcentaje_con_despacho = totalClientes > 0 ? ((totales.clientes_despachados / totalClientes) * 100).toFixed(1) : 0
      totales.porcentaje_sin_despacho = totalClientes > 0 ? ((totales.clientes_no_despachados / totalClientes) * 100).toFixed(1) : 0

      totales.porcentaje_cumplimiento = planificadas > 0 ? ((cumplidas / planificadas) * 100).toFixed(1) : 0

      return totales
    }
  },
  mounted () {
    this.actualizar()
  },
  watch: {
    fechaMes () {
      this.actualizar()
    }
  },
  methods: {
    restablecerFiltros () {
      this.restablecer = true
      this.fechaMes = (new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2)).toString()
      this.actualizar()
    },
    actualizar () {
      this.cargando = true
      const data = this.fechaMes ? 'ver_ano=' + this.fechaMes.substring(0, 4) + '&ver_mes=' + this.fechaMes.substring(5, 7) : ''
      apiPost({ s: 'actividadesTodosMv' }, data)
        .then((res) => {
          this.cargando = false
          this.data = res.data.vendedores
        }).catch(() => {
          this.alertaMensaje = {
            contenido: 'Ocurrió un error obteniendo los datos',
            tipo: 'error'
          }
        })
    },
    convertirValorAFixed (numero) {
      return convertirNumeroAFixed(numero)
    },
    mesDelAño () {
      const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ]
      return meses[parseInt(this.fechaMes.split('-')[1], 10) - 1]
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 80dvw;
  margin: 0 auto;
  padding: 20px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px #dddddd solid;
  background-color: #fafafa;
}

th {
  font-weight: 600;
  text-align: left;
  padding: 10px 12px;
  white-space: nowrap;
  font-size: .7rem;
  text-transform: uppercase;
}

th:last-child {
  border-right: none;
}

td {
  padding: .4rem;
  padding-bottom: 0;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  font-size: .75rem;
}

tr:hover td {
  background-color: #f9f9f9;
}

// tr:nth-child(even) {
//   background-color: #f8f9fa;
// }

tr:nth-child(even):hover td {
  background-color: #f1f3f4;
}

.fila-totales {
  background-color: #f0f4f8;
  border-top: 2px solid #dee2e6;
  font-weight: 600;
}

.fila-totales td {
  border-bottom: none;
  background-color: #f0f4f8;
}

.celda-destacada-amarilla {
  background-color: #fff3cd !important;
  border-left: 3px solid #ffc107 !important;
}

.table-container {
  border: 1px solid #e7e6e6;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 30px;
}

.table-wrapper {
  overflow: auto;
  max-height: 80dvh;
}

.ancho-1 {
  width: 300px;
}

.ancho-2 {
  width: 200px;
}

.ancho-3 {
  width: 100px;
}

.table.actividades {
  // Define los breakpoints para el responsive de ul.table
  @include ul-table-responsive-at ("576px");
}

.tabla-container {
  overflow: auto;
}

.contenedor-tabla {
  max-width: 80dvw;
}

@media (max-width: 1020px) {
  .container {
    width: 100dvw;
    padding: 0px;
  }

  .table-wrapper {
    width: 100dvw;
  }
}

@media (max-width: 576px) {
  .table-wrapper {
    max-height: none;
    overflow-x: hidden;
  }

  table {
    width: 100%;
  }

  thead {
    display: none;
  }

  tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid black;
    width: 90%
  }

  td {
    display: flex;
    flex-wrap: nowrap;
    padding-top: .5rem !important;
    padding-bottom: 0rem !important;
    height: auto !important;
    border: none;
    width: 90% !important;
    min-width: 0;
  }

  td::before {
    content: attr(data-columna) "                          " attr(second-data-columna);
    white-space: pre-wrap;
    font-weight: 500;
    margin-right: .25rem;
    min-width: 105px;
    width: 105px !important;
    flex-shrink: 0;
  }

  td>div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  td>div>p,
  td>div>span {
    word-break: break-word;
    overflow-wrap: break-word;
    min-width: 0;
  }
}
</style>
